// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-warning-container {
  width: 320px;
  height: auto;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}

.modal-warning-header {
  font-size: 16px !important;
  font-weight: 800 !important;
  margin-bottom: 20px !important;
}

.modal-warning-text {
  font-size: 16px !important;
  margin-bottom: 20px !important;
  line-height: 1.4;
}

.modal-warning-highlight {
  font-weight: 800;
}

.modal-warning-checkbox-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.modal-warning-checkbox-text {
  font-size: 16px !important;
  margin-left: 10px !important;
  white-space: nowrap;
}

.modal-warning-button-container {
  display: flex;
  justify-content: center;
  padding: 0px;
  gap: 24px;
}

.modal-warning-cancel-button {
  background-color: #E5E5E5 !important;
  color: #002129 !important;
  height: 40px;
}
.modal-warning-cancel-button:hover {
  background-color: #E5E5E5 !important;
  color: #002129 !important;
}

.modal-warning-submit-button {
  height: 40px;
  background-color: #00AAD1 !important;
  color: white !important;
}
.modal-warning-submit-button:hover {
  background-color: #00AAD1;
}`, "",{"version":3,"sources":["webpack://./src/components/GameModals/WarningModal/WarningModal.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,8BAAA;AACJ;;AAEA;EACI,0BAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,4BAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;AACJ;;AAEA;EACI,oCAAA;EACA,yBAAA;EACA,YAAA;AACJ;AAAI;EACI,oCAAA;EACA,yBAAA;AAER;;AAEA;EACI,YAAA;EAEA,oCAAA;EACA,uBAAA;AAAJ;AACI;EACI,yBAAA;AACR","sourcesContent":[".modal-warning-container {\n    width: 320px;\n    height: auto;\n    padding: 16px;\n    background-color: white;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    position: fixed;\n    text-align: center;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1000;\n}\n\n.modal-warning-header {\n    font-size: 16px !important;\n    font-weight: 800 !important;\n    margin-bottom: 20px !important;\n}\n\n.modal-warning-text {\n    font-size: 16px !important;\n    margin-bottom: 20px !important;\n    line-height: 1.4;\n}\n\n.modal-warning-highlight {\n    font-weight: 800;\n}\n\n.modal-warning-checkbox-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.modal-warning-checkbox-text {\n    font-size: 16px !important;\n    margin-left: 10px !important;\n    white-space: nowrap;\n}\n\n.modal-warning-button-container {\n    display: flex;\n    justify-content: center;\n    padding: 0px;\n    gap: 24px;\n}\n\n.modal-warning-cancel-button {\n    background-color: #E5E5E5 !important;\n    color: #002129 !important;\n    height: 40px; // Adjust height to match the default button size\n    &:hover {\n        background-color: #E5E5E5 !important;\n        color: #002129 !important;\n    }\n}\n\n.modal-warning-submit-button {\n    height: 40px; // Adjust height to match the default button size\n    // The default MUI color for 'contained' button is applied here\n    background-color: #00AAD1 !important; // Default blue color, adjust as needed\n    color: white !important;\n    &:hover {\n        background-color: #00AAD1; // Darker blue on hover\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
